import { theme } from '@by-miles/bymiles-styles'

export const getCookie = name => {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

export const setCookie = (name, value, days) => {
  const d = new Date()
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}

export const deleteCookie = name => {
  setCookie(name, '', -1)
}

export const stickyBannerCookieHeight = () => {
  if (window.innerWidth >= theme.grid.resolution.tablet.width) {
    return '122px'
  }
  return '138px'
}
